module.exports = {"140621001":"东城管理委员会","140621002":"西城管理委员会","140621100":"玉井镇","140621101":"北周庄镇","140621102":"古城镇","140621103":"岱岳镇","140621200":"吴马营乡","140621201":"马营乡","140621202":"下喇叭乡","140621203":"合盛堡乡","140621205":"安荣乡","140621206":"薛圐圙乡","140621207":"后所乡","140621208":"张家庄乡","140621209":"马营庄乡","140621400":"山阴农牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140621.json
// module id = 277
// module chunks = 0